import React from 'react';
import parse from 'date-fns/parse';
import isWithinRange from 'date-fns/is_within_range';
import { Grid, Cell } from 'formlabs-web-components/Grid';
import './NotificationBanner.module.css';

const NotificationBanner = ({ startDate, endDate, message }) => {
  const start = new Date(parse(startDate));
  const end = new Date(parse(endDate));

  if (!isWithinRange(Date.now(), start, end)) {
    return null;
  }
  return (
    <div role="banner" styleName="banner">
      <Grid direction="x" hasContainer={true}>
        <Cell smallSize={24}>
          <p>{message}</p>
        </Cell>
      </Grid>
    </div>
  );
};

export default NotificationBanner;
